import { BehaviorSubject } from 'rxjs';

// public sub
const _logoutListener = new BehaviorSubject<{ action: string; [key: string]: any }>({
  action: null,
});
export const logoutListener = _logoutListener.asObservable();

// private publicator
export const logoutChannel = {
  send: msg => {
    _logoutListener.next({
      ...msg,
    });
  },
  clear: () => {
    _logoutListener.next({
      action: null,
    });
  },
};
